import type { IFilterPanelBaseFilterDeps, IFilterPanelBaseFilterModel } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";

import type { IAppsPriceFilterDto } from "../../types/commonFiltersDto";
import type { IAppsPriceFilterDescriptionDto } from "../../types/descriptionDto";

type IAppsPriceFilterOptions = readonly number[];

export default class FindAppsPriceFilter
    extends FilterPanelBaseFilter<IAppsPriceFilterDto, IAppsPriceFilterDescriptionDto>
    implements IFilterPanelBaseFilterModel<IAppsPriceFilterDto, IAppsPriceFilterDescriptionDto>
{
    readonly minOptions: IAppsPriceFilterOptions;
    readonly maxOptions: IAppsPriceFilterOptions;

    constructor(deps: IFilterPanelBaseFilterDeps<IAppsPriceFilterDto, IAppsPriceFilterDescriptionDto>) {
        super(deps);

        const {
            options: { buckets },
        } = deps;

        this.minOptions = buckets.slice(0, buckets.length - 1);
        this.maxOptions = buckets.slice(1);
    }
}
